import { Controller } from "@hotwired/stimulus";

export default class extends Controller {

  disconnectDevice() {
    try {
      fetch("/devices/disconnect", {
        method: "POST",
        headers: {
          "X-CSRF-Token": document.querySelector("meta[name='csrf-token']").content,
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          device: {
            endpoint: localStorage.getItem('endpoint')
          }
        })
      });
      localStorage.removeItem('endpoint')

    } catch (error) {
      console.error("Error al eliminar el dispositivo:", error);
    }
  }
}
